import { useState } from "react";
import CustomLabel from "../common/CustomLabel";
import LoadingAnimation from "../common/LoadingAnimation";
import { useAdminLogin } from "../hooks/useAdminLogin";
import ErrorModal from "../modals/ErrorModal";
import { FaEye, FaEyeSlash } from "react-icons/fa6";

const AdminLogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const {
    loginDetails,
    errors,
    loading,
    loginError,
    setLoginError,
    handleDetailsChange,
    handleLogin,
    isFormValid,
  } = useAdminLogin();

  const clearError = () => {
    setLoginError({ error: false, message: undefined });
  };

  return (
    <form
      onSubmit={handleLogin}
      className="relative flex flex-col justify-center items-center h-full text-white text-center pt-[40px] pb-[40px]"
    >
      <div className="flex flex-col mb-[80px] w-[calc(100%-64px)] sm:w-[454px] gap-6">
        <CustomLabel
          labelTextClass="text-white px-4"
          labelWrapClass="text-left !gap-1"
          labelText="E-mail"
          // isRequired
        >
          <input
            type="email"
            name="email"
            placeholder="Enter your e-mail"
            value={loginDetails.email || ""}
            onChange={handleDetailsChange}
            className={`font-medium text-sm leading-4 text-gray-7 w-full border-[1.5px] p-[18px] pr-[38px] rounded-[50px] outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer ${
              errors.email ? "border-danger" : "border-gray-7"
            }`}
          />

          {errors.email && (
            <p className="text-danger font-normal text-[10px] leading-3 mt-1 px-4">
              {errors.email}
            </p>
          )}
        </CustomLabel>

        <CustomLabel
          labelTextClass="text-white px-4"
          labelWrapClass="text-left !gap-1"
          labelText="Password"
          // isRequired
        >
          <div className="relative w-full">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Enter your password"
              value={loginDetails.password || ""}
              onChange={handleDetailsChange}
              className={`font-medium text-sm leading-4 text-gray-7 w-full border-[1.5px] [&::-ms-reveal]:hidden [&::-ms-clear]:hidden ${
                errors.password ? "border-danger" : "border-gray-7"
              } p-[18px] pr-[38px] rounded-[50px] outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer`}
            />
            <button
              type="button"
              className="absolute inset-y-0 right-4 flex items-center text-gray-7"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? (
                <span className="material-icons">
                  <FaEyeSlash size={20} className="text-dark-7" />
                </span>
              ) : (
                <span className="material-icons">
                  <FaEye size={20} className="text-dark-7" />
                </span>
              )}
            </button>
          </div>

          {errors.password && (
            <p className="text-danger font-normal text-[10px] leading-3 mt-1 px-4">
              {errors.password}
            </p>
          )}
        </CustomLabel>
      </div>

      <div className="flex flex-col gap-6">
        <a
          className="text-lg leading-[22px] font-extrabold text-white"
          href="/admin/forgot-password"
        >
          Forgot your password?
        </a>
        <button
          // onClick={handleLogin}
          type="submit"
          disabled={!isFormValid || loading}
          className="text-lg leading-[22px] font-extrabold min-w-[300px] text-gray-7 bg-white disabled:bg-gray-3 disabled:text-gray-4 py-[14px] px-[101px] rounded-[24px]"
        >
          {loading ? <LoadingAnimation /> : "Login"}
        </button>
      </div>

      {loginError.error && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-md z-50">
          <ErrorModal
            onAccept={clearError}
            onClose={clearError}
            errorDescription="We encountered an error while logging you in, please try again."
          />
        </div>
      )}
    </form>
  );
};

export default AdminLogin;
